<template>
    <SiteNavigation
        :floating-logo="themeSetting('logo_type') == 1 ? true : false"
        :centered-logo="themeSetting('center_logo') == 1 && !themeSetting('powered_by_monevo') ? true : false"
    >
        <template v-slot:logo>
            <ConditionalLink
                v-if="isLogoClickEnabled"
                :type="themeSetting('partner_callback_url') ? 'external' : null"
                :link="themeSetting('partner_callback_url') || url('/')"
                :router="false"
                :target="homepageLogoTargetBlank"
            >
                <img :src="themeSetting('logo')" alt="Monevo" v-if="themeSetting('logo')" />
                <img :src="asset('/img/logos/logo-monevo.svg?v=2')" alt="Monevo" v-else />
            </ConditionalLink>

            <div v-else>
                <img :src="themeSetting('logo')" alt="Monevo" v-if="themeSetting('logo')" />
                <img :src="asset('/img/logos/logo-monevo.svg?v=2')" alt="Monevo" v-else />
            </div>
        </template>

        <template v-slot:co-branding-logo>
            <div v-if="themeSetting('powered_by_monevo') || coBranding?.logo">
                <PartnerLogo alignment="right" />
            </div>
        </template>

        <template v-slot:step-indicator>
            <div class="col d-none d-lg-flex justify-content-center">
                <StepProgressIndicator />
            </div>
        </template>
    </SiteNavigation>
</template>

<script>
import { useStore } from 'vuex'

export default {
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    computed: {
        pageData: function () {
            return this.store.state.global.page || null
        },
        isLogoClickEnabled: function () {
            return parseInt(this.themeSetting('disable_logo_click')) !== 1
        },
        menu: function () {
            return this.store.state.global.data.menu || {}
        },
        menuMisc: function () {
            return this.menu.misc
        },
        coBranding: function () {
            if (this.pageData && this.pageData.cobranding_logo) {
                return {
                    logo: this.pageData && this.pageData.cobranding_logo,
                    text: this.pageData && this.pageData.cobranding_text,
                }
            }

            return null
        },
        homepageLogoTargetBlank: function () {
            return this.themeSetting('homepage_logo_target_blank') === '1' ? '_blank' : ''
        },
    },
}
</script>
